/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */
import { classNames } from '../utils/UNSAFE_classNames';
import { Metadata } from '../UNSAFE_Collection';

const SPARKLE_STYLE_CLASS = 'oj-collection-sparkle';

import { sparkleStyles } from './themes/ListStyles.css';

/**
 * A sparkle component for smart suggestion indicator in ListView
 * @param sparkleHeight the height of sparkle
 */
export function Sparkle({ sparkleHeight }: { sparkleHeight: number }) {
  if (sparkleHeight <= 0) {
    return null;
  }

  const height = sparkleHeight + 'px';
  const sparkleClasses = classNames([sparkleStyles.base]);
  const containerClasses = classNames([sparkleStyles.container, SPARKLE_STYLE_CLASS]);

  return (
    <div key="sparkle" class={containerClasses}>
      <div class={sparkleClasses} style={{ height }}></div>
    </div>
  );
}

/**
 * A helper function that finds the data with suggestions, and
 * returns the corresponding keys
 * @param dataState
 */
export const findSuggestions = <K, D>(
  data: { data: D; metadata: Metadata<K> }[],
  count: number
) => {
  if (count === 0) {
    return null;
  }

  const suggestionsData = data.slice(0, count);
  return suggestionsData.reduce((suggestions, value, index) => {
    const key = value.metadata.key;

    if (index === count - 1) {
      suggestions.set(key, 'end');
    } else {
      suggestions.set(key, true);
    }

    return suggestions;
  }, new Map<K, 'end' | true>());
};
